export default "__VITE_ASSET__DiSwK4wP__"